import React from 'react';
import LoginForm from '../components/Auth/LoginForm';
import SocialLogin from '../components/Auth/SocialLogin';

const LoginPage: React.FC = () => (
  <>
    <LoginForm />
    <SocialLogin />
  </>
);

export default LoginPage; 